module.exports = __webpack_public_path__ + "static/img/play-multiplayers.67a3646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-multiplayers.jpg
// module id = dm+R
// module chunks = 1